module.exports = __webpack_public_path__ + "static/media/workingmemory-words-10.f1674ba4.mp3";